import type { KeyboardEvent } from 'react';

/**
 * Returns a keydown handler for text inputs inside a dropdown/popover form.
 * - Space: prevented so it doesn't accidentally close the dropdown.
 * - Enter: calls onSubmit.
 * - Escape: calls onDismiss.
 */
export function makeDropdownInputKeyHandlers({
  onSubmit,
  onDismiss
}: {
  onSubmit: () => void;
  onDismiss: () => void;
}): (e: KeyboardEvent) => void {
  return (e) => {
    if (e.key === ' ') e.preventDefault();
    if (e.key === 'Enter') onSubmit();
    if (e.key === 'Escape') onDismiss();
  };
}
